import images from "./imagesImport";
import { useEffect, useState, useRef } from "react";
import useIsSmallScreen from "../../components/isSmallScreen";
import ImageFetcher from "../../components/ImageFetcher";

const Thumbnails = ({ showImage }) => {
  const [scrollDirection, setScrollDirection] = useState(null); // 'left', 'right', or null
  const [thumbnailImages, setThumbnailImages] = useState(images);
  const isSmallScreen = useIsSmallScreen();
  const thumbnailsRef = useRef(null);
  const animationFrameRef = useRef(null);

  const onMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const relativeX = e.clientX - rect.left;
    const containerWidth = rect.width;

    // Left third: scroll left, right third: scroll right, middle: stop
    if (relativeX < containerWidth / 3) {
      setScrollDirection("left");
    } else if (relativeX > (2 * containerWidth) / 3) {
      setScrollDirection("right");
    } else {
      setScrollDirection(null);
    }
  };
  // attach mousemove listener
  useEffect(() => {
    if (!isSmallScreen) {
      checkAndFillImages();
    }
    if (isSmallScreen) return; // disable on mobile
    const el = thumbnailsRef.current;
    if (!el) return;

    el.addEventListener("mousemove", onMouseMove);

    return () => {
      setThumbnailImages(images); // reset images on unmount
      el.removeEventListener("mousemove", onMouseMove);
    };
  }, [isSmallScreen]);

  // auto scroll function
  const scroll = (e) => {
    if (!scrollDirection) {
      animationFrameRef.current = null;
      return;
    }

    const maxScrollLeft = e.scrollWidth - e.clientWidth;

    if (scrollDirection === "left") {
      if (e.scrollLeft > 0) {
        e.scrollLeft -= 0.5;
        animationFrameRef.current = requestAnimationFrame(() => scroll(e));
      } else {
        animationFrameRef.current = null;
      }
    } else if (scrollDirection === "right") {
      if (e.scrollLeft < maxScrollLeft) {
        e.scrollLeft += 0.5;
        animationFrameRef.current = requestAnimationFrame(() => scroll(e));
      } else {
        animationFrameRef.current = null;
      }
    }
  };
  // trigger scroll on direction change
  useEffect(() => {
    if (isSmallScreen) return; // disable on mobile
    const el = thumbnailsRef.current;
    if (!el) return;

    if (scrollDirection && !animationFrameRef.current) {
      animationFrameRef.current = requestAnimationFrame(() => scroll(el));
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
    };
  }, [scrollDirection]);

  // check if images does not fill whole width add same images again
  const checkAndFillImages = () => {
    const el = thumbnailsRef.current;
    if (!el) return;
    let totalImageWidth = 0;
    for (let img of el.children) {
      totalImageWidth += img.clientWidth;
    }
    if (totalImageWidth < el.clientWidth) {
      setThumbnailImages((prev) => [...prev, ...images]);
    }
  };
  return (
    <div className="thumbnails" ref={thumbnailsRef}>
      {thumbnailImages.map((img, index) => (
        <div key={index} onClick={() => showImage(img)}>
          <ImageFetcher
            image={img}
            name="thumbnail-image"
            width={120}
            height={200}
          />
        </div>
      ))}
    </div>
  );
};

export default Thumbnails;
